export default {
    guidancePaper: {
        icon: 'file-sync',
        text: 'Bimbingan',
        route: 'admin.paper.guidance',
        role: {
            paper: [ 'attendant' ],
        }
    },
    approval: {
        icon: 'file-done',
        text: 'Approval',
        route: 'admin.paper.approval',
        role: {
            paper: [ 'attendant' ],
        }
    },
    scorePaper: {
        icon: 'file-protect',
        text: 'Nilai',
        route: 'admin.paper.score',
        role: {
            paper: [ 'attendant' ],
        }
    },
    notulenPaper: {
        icon: 'file-text',
        text: 'Notulen Makalah',
        route: 'admin.paper.notulen',
        role: {
            paper: [ 'attendant' ],
        }
    },
    guidancePaperSummary: {
        icon: 'file-sync',
        text: 'Bimbingan Makalah',
        route: 'admin.paper.guidance.summary',
        role: {
            paper: [ 'advisor' ],
        }
    },
    guidancePaperSummaryMentor: {
        icon: 'file-sync',
        text: 'Validasi Makalah',
        route: 'admin.paper.guidance.summary',
        role: {
            paper: [ 'mentor' ],
        }
    },
    scoringPaper: {
        icon: 'file-protect',
        text: 'Penilaian Makalah',
        route: 'admin.paper.scoring',
        role: {
            paper: [ 'mentor', 'evaluator', 'advisor' ],
        }
    },
    paperRecap: {
        icon: 'control',
        text: 'Performance Mentor',
        route: 'admin.paper.mentoring.recap',
        role: {
            paper: [ 'mentor' ],
        },
    }
}
